document.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.getElementById("dictionary-search");
  const letterGroups = document.querySelectorAll(".dictionary-letter-group");

  if (!searchInput) return;

  searchInput.addEventListener("input", () => {
    const query = searchInput.value.toLowerCase();

    letterGroups.forEach((group) => {
      const items = group.querySelectorAll(".dictionary-item");
      let hasMatch = false;

      items.forEach((item) => {
        const term = item.dataset.term;
        const match = term.includes(query);
        item.style.display = match ? "" : "none";
        if (match) hasMatch = true;
      });

      // hide entire letter group if no matches
      group.style.display = hasMatch ? "" : "none";
    });
  });
});
